/**
 * Nudges WalkMe to re-scan the DOM after a client-side route change: react-router's `pushState`
 * emits no native `popstate`, so we re-emit one (react-router just recomputes the unchanged
 * location, so no navigation occurs).
 */
export const notifyWalkMe = (): void => {
  if (typeof window === 'undefined') return;
  if (!window.WalkMeAPI) return;

  window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
};
